let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kelo3")).then(() => parcelRequire('dP9Iy'));